__turbopack_context__.v({
  "articleCount": "AuthorArticlesResultsTable-module-scss-module__C4u2Fq__articleCount",
  "moreButton": "AuthorArticlesResultsTable-module-scss-module__C4u2Fq__moreButton",
  "title": "AuthorArticlesResultsTable-module-scss-module__C4u2Fq__title",
  "wrapper": "AuthorArticlesResultsTable-module-scss-module__C4u2Fq__wrapper",
});
